import helper from './helper'

const userhelper = {
  getLoginState: function () {
    var uinfo = null
    uinfo = helper.getUser()
    if (!uinfo) {
      return false
    } else {
      return true
    }
  }
}
export default userhelper



// WEBPACK FOOTER //
// ./src/lib/user.js